<template>
    <ac-modal :title="modalTitle" ref="modal">
        <template>
            <div v-if="widgetReady">
                <div class="row">
                    <div class="col-md-6" v-if="isAdminPrimary">
                        <label>Group</label>
                        <select class="form-control" v-model="vm.companyId">
                            <option v-for="c in companies" :key="c.companyId" :value="c.companyId">
                                {{ c.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-6" v-else>
                        <p>Group: {{ vm.employer }}</p>
                    </div>
                </div>
                <div class="row" style="padding: 15px 0px;">
                    <div class="col-lg-4" v-if="isPrimary">
                        <label>Primary Email Address</label>
                        <input type="text" class="form-control" v-model="vm.emailAddress" />
                    </div>
                    <div class="col-lg-4">
                        <div class="form-group">
                            <label>Benefits Start On</label><br />
                            <ac-date-picker v-model="vm.newEffectiveDate">
                            </ac-date-picker>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Select</th>
                                    <th>Name</th>
                                    <th>Relationship</th>
                                    <th>DOB</th>
                                    <th>End Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="d in family" :key="d.consumerId">
                                    <td>
                                        <input type="checkbox" class="form-control select-checkbox" v-model="d.isSelected"
                                            :id="'dependent-to-terminate-' + d.consumerId">
                                    </td>
                                    <td>
                                        <label :for="'dependent-to-terminate-' + d.consumerId">{{ d.firstName + " " + d.lastName }}</label>
                                    </td>
                                    <td>
                                        <p>{{ d.consumerRelationship }}</p>
                                    </td>
                                    <td>
                                        <p>{{ d.birthDate | shortDate }}</p>
                                    </td>
                                    <td>
                                        <p>{{ d.effEndDate | shortDate }}</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </template>
        <template slot="buttons">
            <ac-button :action="reactivate">Reactivate</ac-button>
        </template>
    </ac-modal>
</template>

<script>
import { api } from "../../../../global/framework/api.js";
import AcCoverageDropDown from "../../../../components/custom/AcCoverageDropDown.vue";
import { configTables } from "../../../../global/configTables.js";

export default {
    name: "ConsumerReactivationModal",
    components: { AcCoverageDropDown },
    data() {
        return {
            widgetReady: false,
            vm: {},
            companies: [],
            family: [],
            relationshipTypes: [],
            entityType: '',
            companyId:0,
            primaryId:0,
            isPrimary:false
        };
    },
    computed: {
        modalTitle() {
            return `Member Account Reactivation - ${this.vm.firstName} ${this.vm.lastName}`;
        },
        isAdminPrimary() {
            return this.entityType === 'admin' && this.isPrimary;
        }
    },
    async mounted() {
        await configTables.getRelationshipsToPrimary()
            .then((r) => this.relationshipTypes = r);
    },
    methods: {
        async showModal({ consumerId, entityType, companyId = null, isPrimary = false }) {
            this.isPrimary = isPrimary;
            this.entityType = entityType;
            this.primaryId = consumerId;
            this.companyId = companyId ? companyId : 0;

            const endpoint = this.isPrimary
                ? 'GetDependentsInfoForReactivationForTermedPrimary'
                : 'GetDependentsInfoForReactivationForActivePrimary';

            let data, family, companies = [];
            [data, family, companies ] = entityType === 'admin'
                ? await Promise.all([
                    api.get('Admin', consumerId, 'GetConsumerReactivationData'),
                    api.get('Admin', consumerId, endpoint),
                    api.getNoId('Admin', 'Companies')
                ])
                : await Promise.all([
                    api.getDataWithTwoIds('Company', companyId, 'GetConsumerReactivationData', consumerId),
                    api.getDataWithTwoIds('Company', companyId, endpoint, consumerId)
                ]);

            family.forEach(mem => mem.consumerRelationship = mem.relationshipToConsumer);
            this.companies = companies;
            this.family = family;
            this.mapData('vm', data);

            this.widgetReady = true;
            this.$refs.modal.open();
        },
        async reactivate() {
            this.vm.dependentsToReactivate = this.family
                .filter(member => member.isSelected);

            const baseUrl = this.entityType === 'admin' ? 'Admin' : 'Company';
            const action = this.isPrimary ? 'ReactivateAccount' : 'ReactivateDependentAccount';

            const urlSuffix = this.entityType === 'admin'
                ? action
                : `${this.companyId}/${action}/${this.primaryId}`;

            await api.post(baseUrl, urlSuffix, this.vm);
            this.$emit("modal-closed");
            this.$refs.modal.close();
        }
    }
}

</script>

<style scoped>
/* .row {
    margin-top: 10px;
} */
.select-checkbox {
    position: unset;
    visibility: visible;
    height: 20px;
    width: 20px;
    margin: 0px 0px 5px;
}

tr,
td,
label {
    vertical-align: unset !important;
}

p {
    margin: 0px 0px 5px;
}
</style>